import { authenticated } from '../../helpers/auth-header';
import insighttAPI from '../clients/insightt-api-client';
import { shiftEndpoints } from '../endpoints';

const getShiftStatus = () => authenticated(insighttAPI).get(shiftEndpoints.getShiftStatusAPI());

const startShift = (shiftType, shiftId, payload) =>
  authenticated(insighttAPI).post(shiftEndpoints.startShiftAPI(shiftType, shiftId), payload);

const pauseShift = (shiftTimeId, payload) =>
  authenticated(insighttAPI).post(shiftEndpoints.pauseShiftAPI(shiftTimeId), payload);

const resumeShift = (shiftTimeId, payload) =>
  authenticated(insighttAPI).post(shiftEndpoints.resumeShiftAPI(shiftTimeId), payload);

const takeBreak = (shiftTimeId, breakId, payload) =>
  authenticated(insighttAPI).post(shiftEndpoints.takeBreakAPI(shiftTimeId, breakId), payload);

const endBreak = (shiftTimeId, breakTimeId, payload) =>
  authenticated(insighttAPI).post(shiftEndpoints.endBreakAPI(shiftTimeId, breakTimeId), payload);

const endShift = (shiftTimeId, payload) =>
  authenticated(insighttAPI).post(shiftEndpoints.endShiftAPI(shiftTimeId), payload);

const trackLocation = (shiftTimeId, payload) =>
  authenticated(insighttAPI).post(shiftEndpoints.trackLocationAPI(shiftTimeId), payload);

const getShiftRepossessionsOverview = (shiftTimeId) =>
  authenticated(insighttAPI).get(shiftEndpoints.getShiftRepossessionsOverviewAPI(shiftTimeId));

const getShiftRepossessionsGoals = (shiftId) =>
  authenticated(insighttAPI).get(shiftEndpoints.getShiftRepossessionsGoalsAPI(shiftId));

const getShiftRepossessionsHitList = (branchId) =>
  authenticated(insighttAPI).get(shiftEndpoints.getShiftRepossessionsHitListAPI(branchId));

const getSpottedVehicleByVin = (shiftTimeId, vin) =>
  authenticated(insighttAPI).get(shiftEndpoints.getSpottedVehicleByVinAPI(shiftTimeId, vin));

const submitSpottedVehicle = (shiftTimeId, payload) =>
  authenticated(insighttAPI).post(shiftEndpoints.submitSpottedVehicleAPI(shiftTimeId), payload);

const getShiftInfractions = (shiftTimeId) =>
  authenticated(insighttAPI).get(shiftEndpoints.getShiftInfractionsAPI(shiftTimeId));

const getShiftPendingInfractions = (shiftTimeId) =>
  authenticated(insighttAPI).get(shiftEndpoints.getShiftPendingInfractionsAPI(shiftTimeId));

const answerInfraction = (breakId, payload) =>
  authenticated(insighttAPI).post(shiftEndpoints.answerInfractionAPI(breakId), payload);

export const shiftService = {
  getShiftStatus,
  startShift,
  pauseShift,
  resumeShift,
  takeBreak,
  endBreak,
  endShift,
  trackLocation,
  getShiftRepossessionsOverview,
  getShiftRepossessionsGoals,
  getShiftRepossessionsHitList,
  getSpottedVehicleByVin,
  submitSpottedVehicle,
  getShiftInfractions,
  getShiftPendingInfractions,
  answerInfraction,
};
